import axios from 'axios';

const baseUrl = process.env.VUE_APP_ROOT_API;

const state = {
  motivos: [],
};

const getters = {
  // Motivo
  motivos: state => state.motivos.sort((a, b) => a.Descricao > b.Descricao ? 1 : -1),
  motivosAtivo: state => state.motivos.filter(b => b.Status.startsWith('A')).sort((a, b) => a.Descricao > b.Descricao ? 1 : -1),
}

const actions = {
  // Motivo
  async fetchMotivos({ commit }) {
    const response = await axios.get(`${baseUrl}/motivos`);
    if (response.data) {
      commit('setMotivos', response.data);
    } else {
      commit('setMotivos', []);
    }
  },
  async fetchMotivosSql({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/motivos?idLayoutSql=${args.idLayoutSql}`);
      if (response.data.length) {
        commit('setMotivos', response.data);
      } else {
        commit('setMotivos', []);
      }
    } catch (error) {
      commit('setMotivos', []);
    }
  },
  async addMotivo({ commit }, motivo) {
    const response = await axios.post(`${baseUrl}/motivos`, motivo, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    motivo.IdMotivo = response.data.IdMotivo;
    commit('newMotivo', motivo);
    return response.data.IdMotivo;
  },
  async updateMotivo({ commit }, updMotivo) {
    await axios.put(`${baseUrl}/motivos`, updMotivo, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('updateMotivo', updMotivo);
  },
  async deleteMotivo({ commit }, id) {
    await axios.delete(`${baseUrl}/motivos/${id}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removeMotivo', id);
  },
}

const mutations = {
  // Motivo
  setMotivos: (state, motivos) => state.motivos = motivos,
  newMotivo: (state, motivo) => state.motivos.push(motivo),
  removeMotivo: (state, id) => state.motivos = state.motivos.filter(motivo => motivo.IdMotivo !== id),
  updateMotivo: (state, updMotivo) => {
    const index = state.motivos.findIndex(motivo => motivo.IdMotivo === updMotivo.IdMotivo);
    if (index !== -1) {
      state.motivos.splice(index, 1, updMotivo);
    }
  },
}

export default {
  state,
  getters,
  actions,
  mutations
}